import React from 'react';
import './Services.css';

const services = [
  {
    icon: 'fa-boxes',
    title: 'Industrial product sourcing',
    description: 'Access a broad network of automation, electrical and control products through one responsive supply partner.',
    tags: ['Automation components', 'Electrical equipment', 'Industrial controls']
  },
  {
    icon: 'fa-search',
    title: 'Part identification & cross-reference',
    description: 'Share a part number or application requirement and we will help evaluate compatible options and alternatives.',
    tags: ['Part matching', 'Obsolescence support', 'Product alternatives']
  },
  {
    icon: 'fa-drafting-compass',
    title: 'Engineering selection support',
    description: 'Get practical guidance around product fit, operating requirements, performance and project budget.',
    tags: ['Application review', 'Component selection', 'Specification support']
  },
  {
    icon: 'fa-project-diagram',
    title: 'Project & BOM support',
    description: 'Simplify complex sourcing with coordinated quoting and fulfillment for multi-line projects and bills of materials.',
    tags: ['BOM review', 'Consolidated sourcing', 'Project coordination']
  },
  {
    icon: 'fa-truck-loading',
    title: 'Inventory & fulfillment',
    description: 'Source in-stock products quickly and receive clear communication about availability, lead times and delivery.',
    tags: ['Live inventory', 'Order visibility', 'Regional delivery']
  },
  {
    icon: 'fa-headset',
    title: 'Ongoing customer support',
    description: 'Work with a team that stays available after the order for follow-up questions and future requirements.',
    tags: ['Responsive service', 'Order follow-up', 'Long-term support']
  }
];

const Services = () => (
  <section id="services" className="va-services">
    <div className="va-container">
      <div className="va-services-heading">
        <div>
          <span className="va-eyebrow va-eyebrow-dark">What we do</span>
          <h2>Support that fits<br />the way industry buys.</h2>
        </div>
        <div>
          <p>
            Whether you need one replacement component or coordinated sourcing for
            a complete project, our team helps reduce the time between requirement
            and result.
          </p>
          <a href="#contact">Discuss a requirement <span>↓</span></a>
        </div>
      </div>

      <div className="va-services-grid">
        {services.map((service, index) => (
          <article key={service.title}>
            <div className="va-service-topline">
              <span>0{index + 1}</span>
              <i className={`fas ${service.icon}`} aria-hidden="true" />
            </div>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
            <ul>
              {service.tags.map((tag) => <li key={tag}>{tag}</li>)}
            </ul>
          </article>
        ))}
      </div>

      <div className="va-service-callout">
        <div>
          <span className="va-eyebrow">Not sure where to start?</span>
          <h3>Send the part number, a photo or your complete list.</h3>
        </div>
        <p>
          Our team will review the requirement and help define a practical next step.
          You do not need to have every technical detail ready.
        </p>
        <a href="#contact">Start a conversation <b>→</b></a>
      </div>
    </div>
  </section>
);

export default Services;
